var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.MStateBox,{attrs:{"loading":_setup.question.loading,"empty":_setup.isEmpty}},[_c('div',{staticClass:"qna-wrapper"},_vm._l((_setup.qnaList),function(item,index){return _c(_setup.RowInfoQnA,{key:index,attrs:{"border":index != _setup.qnaList.length - 1,"item":item}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }